import React, { useContext } from 'react';
import { type ILayerProps } from '@/version-types';
import { FeatureChecker } from '../../utils';
import { TextLayerContext } from '../context';

type Props = {
    href: string;
    layer: ILayerProps;
};

export const TextUse: React.FC<Props> = ({ href, layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const isUsingGradient = FeatureChecker.usingGradient(layer);
    const isUsingTexture = FeatureChecker.usingTexture(layer);
    const fill = (() => {
        if (isUsingGradient) return `url(#gradient-${layer.id}-${defIDSuffix})`;
        if (isUsingTexture) return `url(#texture-${layer.id}-${defIDSuffix})`;
        return undefined;
    })();

    return <use xlinkHref={href} fill={fill} />;
};
